// removed by extract-text-webpack-plugin
module.exports = {"Main":"src-containers-AppUser-__AppUserPage-module___Main"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/AppUser/AppUserPage.module.css
// module id = 1182
// module chunks = 1